import { useModal } from 'mui-modal-provider';

import {
  OmniCredentialsDialog,
  OmniCredentialsDialogProps,
} from './OmniCredentialsDialog';

import { ShowModalOutput } from '@cast/design-system';

export const useAssignOmniCredentialsDialog = () => {
  const { showModal } = useModal();

  let modalInstance: ShowModalOutput;

  const openOmniCredentialsDialog = ({
    cluster,
    onCreateEdgeLocationClick,
  }: OmniCredentialsDialogProps) => {
    modalInstance = showModal(OmniCredentialsDialog, {
      cluster,
      onCreateEdgeLocationClick,
      onClose: () => modalInstance.destroy(),
    });
  };

  return { openOmniCredentialsDialog };
};
